import $http from "../../axios";
import { Notification } from "element-ui";

export async function getVehiclesBylicensePlate({ commit, state }) {
  var params = {
    params: state.paramsGetvehicles
  };

  $http
    .get("/api/vehiculos-terceros", params)
    .then(response => {
      commit("setVehiclesVehicleStories", response.data.data);
    })
    .catch(error => {
      Notification.error({
        title: "¡Error!",
        message: "Error al traer el vehiculo.",
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function getPdfVehicleStories({ commit, state }) {
  commit("setLoadingPdf", true);
  commit("resetFileNamePdfVehicleStories");

  var params = {
    params: {
      contact_id: state.selectedVehicle.contact_id,
      contact_vehicle_id: state.selectedVehicle.id
    }
  };

  $http
    .get("/api/historias-vehiculos", params)
    .then(response => {
      commit("setFileNamePdfVehicleStories", response.data);
      commit("setShowPdfVehicleStories", true);
      commit("setLoadingPdf", false);
    })
    .catch(error => {
      commit("setLoadingPdf", false);
      Notification.error({
        title: "¡Error!",
        message: "Error al generar el pdf.",
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function getPdfVehicleStoriesAsync({ commit, state }, params) {
    return await new Promise(async (resolve, reject) => {
      await $http
        .get("/api/historias-vehiculos", { params })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          Notification.error({
            title: "¡Error!",
            message: "Error al generar el pdf.",
            type: "error",
            duration: 1500,
            customClass: "notification-box"
          });
          reject(error)
        });
    });
}

export async function getVehicleStoriesData({ commit, state }, params) {
    return await new Promise(async (resolve, reject) => {
      await $http
        .get("/api/historias-vehiculos-data", { params })
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          Notification.error({
            title: "¡Error!",
            message: "Error al traer la informacion.",
            type: "error",
            duration: 1500,
            customClass: "notification-box"
          });
          reject(error)
        });
    });
}



// WEBPACK FOOTER //
// ./src/modules/vehicle-stories/actions.js